/**
 * 7 loại tồn hiển thị (popover "Hiển thị") — map sang query checkStock API.
 * Không thêm mục ngoài danh sách này.
 */
export const PRODUCT_STOCK_QUANTITY_DISPLAY_OPTIONS = [
  {
    id: 1,
    name: 'Tồn có thể bán',
    checkStock: 'inStockQuantity',
    icon: 'fas fa-check-circle',
    colorClass: 'instock-color',
  },
  {
    id: 2,
    name: 'Đang chuyển kho',
    checkStock: 'transferQuantity',
    icon: 'fas fa-exchange-alt',
    colorClass: 'text-primary',
  },
  {
    id: 3,
    name: 'Đang giữ hàng',
    checkStock: 'holdingQuantity',
    icon: 'fas fa-hand-paper',
    colorClass: 'holding-color',
  },
  {
    id: 4,
    name: 'Đang vận chuyển',
    checkStock: 'deliveryQuantity',
    icon: 'fas fa-truck',
    colorClass: 'delivery-color',
  },
  {
    id: 5,
    name: 'Đang bảo hành',
    checkStock: 'warrantyQuantity',
    icon: 'fas fa-wrench',
    colorClass: 'warranty-color',
  },
  {
    id: 6,
    name: 'Đang lỗi',
    checkStock: 'errorQuantity',
    icon: 'fas fa-exclamation-circle',
    colorClass: 'error-color',
  },
  {
    id: 7,
    name: 'Đang cho mượn',
    checkStock: 'lendingQuantity',
    icon: 'fas fa-handshake',
    colorClass: 'lending-color',
  },
];

/**
 * Map nhanh id -> metadata (icon, màu, tên) để tái sử dụng khi build HTML ô tồn.
 */
export const PRODUCT_STOCK_QUANTITY_DISPLAY_BY_ID =
  PRODUCT_STOCK_QUANTITY_DISPLAY_OPTIONS.reduce((acc, row) => {
    acc[row.id] = row;
    return acc;
  }, {});

export const CHECK_STOCK_VALUES = PRODUCT_STOCK_QUANTITY_DISPLAY_OPTIONS.map(
  (row) => row.checkStock,
);
